<template>
  <div
      :style="{flex:1,'--currentDeviceLevelColor': currentDeviceLevelColor,'--dropdownMenuWidth':dropdownMenuWidth, '--dropdownMenuLeft': dropdownMenuLeft}">
    <van-dropdown-menu ref="dropdownMenu" :style="disableLight">
      <van-dropdown-item ref="dropdownItem" :disabled="disabled">
        <template #title>
          <div
              class="drop-item-level"
          >{{ deviceLevel }}
          </div>
        </template>
        <template>
          <div
              class="drop-item-level__wrap dropdown-menu-custom h-8"
              v-for="(item, index) in levelOption"
              :key="index"
              @click="onLevelDropdown(item)"
              :style="{ }"
          >
            <div
                class="drop-item-level "
                :style="{'borderColor': item.color}"
            >{{ index + 1 }}
            </div>
            <div class="flex-1 text-center">{{ item.text }}</div>
          </div>
        </template>
      </van-dropdown-item>
    </van-dropdown-menu>
  </div>
</template>
<script>
import log from "@/util/log";

export default {
  name: "DropdownDeviceLevelLight",
  props: {
    value: [Number, String],
    level: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isBluetooth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      test: 0,
      dropdownMenuWidth: 0,
      dropdownMenuLeft: 0,

      deviceLevelList: [
        { text: "Low", value: 1, color: "black" },
        { text: "Mid", value: 2, color: "black" }
        // { text: "High", value: 3, color: "red" }
      ],
      currentDeviceLevel: 0,
      currentDeviceLevelItem: { text: "black", value: 0 },

      currentDeviceLevelColor: "black"
    };
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.dropdownMenu.$el;
      const clientWidth = el.clientWidth;
      const offsetLeft = el.offsetLeft;
      this.dropdownMenuWidth = `${clientWidth}px`;
      this.dropdownMenuLeft = `${offsetLeft - 16}px`;
      log(`dropdownMenu = ${clientWidth}`);
    });
  },
  watch: {
    level(val) {
      if (val > 0) {
        this.currentDeviceLevelColor = this.levelOption[this.isBluetooth ? val : val - 1].color;
      } else {
        this.currentDeviceLevelColor = "black";
      }

    }
  },
  methods: {
    onInput(e) {
      this.$refs.dropdownItem.toggle();
      log(e);
      this.$emit("input", e);
    },

    onLevelDropdown(item) {
      this.currentDeviceLevelColor = item.color;
      this.$emit("change", item.value);
      this.$refs.dropdownItem.toggle();
    }
  },
  computed: {

    levelOption() {
      if (this.isBluetooth) {
        return [
          { text: "Low", value: 0, color: "black" },
          { text: "Mid", value: 1, color: "black" }
        ];
      }
      return [
        { text: "Low", value: 1, color: "black" },
        { text: "Mid", value: 2, color: "black" }
      ];
    },
    disableLight() {
      return {
        opacity: this.disabled ? 0.3 : 1
      };
    },
    ingredientText() {
      if (this.value === "") {
        return "Choose Ingredients";
      }
      return this.options[this.value].text;
    },
    ingredientTextClass() {
      if (this.value === "") {
        return "third-color";
      }
      return "";
    },
    deviceLevel() {
      if (!this.level) {
        return 1;
      }
      if (this.isBluetooth) {
        return this.level + 1
      }
      return this.level;
    }
  }
};
</script>


<style scoped lang="less">

/deep/ .van-dropdown-item__option {
  img {
    width: 22px;
    height: 22px;
  }
}

.drop-item-level {
  width: 25px;
  height: 25px;
  border: 2px var(--currentDeviceLevelColor) solid;

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  text-align: center;
  font-size: 14px;
  color: #333333;
}

.drop-item-level__wrap {
  width: 100%;
  padding: 0px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.drop-item-level__content {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  border: 1px #999 solid;
  border-radius: 50%;
}


/deep/ .van-dropdown-item {
  left: 16px;
  width: 32%;
  top: -4px;
  height: 30%;
  border-radius: 5px;
  background: transparent;

  .van-overlay {
    height: auto;
  }

  .van-dropdown-item__content {
    border-radius: 5px;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1607843137254902);
    top: 1px;
    left: 6px;
    right: 5px;
    width: auto;
    max-height: 100px;
  }

  .van-cell {
    height: 25px;
    line-height: 25px;
    padding: 0 0 0 6px;
  }

  .van-cell::after {
    display: none;
  }

  .van-cell__title {
    padding-left: 3px;
    font-size: 11px;
    color: #939598;
    white-space: nowrap;
  }

  .van-dropdown-item__option--active {
    background: var(--dropDownActiveColor);
    border-radius: 5px;

    .van-cell__title {
      color: #ffffff !important;
    }
  }

  .van-dropdown-item__icon {
    color: #6649c4;
  }

  .van-dropdown-item__icon::before {
    display: none;
  }


  .drop-item-level {
    width: 25px;
    height: 25px;
    border: 2px solid;
    border-radius: 50%;
    text-align: center;
    line-height: 25px;
    font-size: 14px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.item-height {
  height: 32px;
  line-height: 32px;
  margin-top: 4px;
  border: 1px solid #E8E8E8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}


::v-deep .van-dropdown-menu {

  .van-dropdown-menu__bar {
    background: transparent;
    box-shadow: none;
  }

  .van-dropdown-menu__title {
    flex: 1;
  }

  .van-dropdown-menu__title::after {
    right: 0px;
  }

  .van-popup--top {
    width: var(--dropdownMenuWidth);
    left: var(--dropdownMenuLeft)
  }

  .van-overlay {
    background-color: transparent;
  }

  .van-cell__title {
    text-align: center;
  }
}

.dropdown-menu-custom {
}


</style>